module.exports = __webpack_public_path__ + "static/img/Post shore 1.0 meter.7ede64e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Post shore 1.0 meter.jpg
// module id = 94
// module chunks = 1